import React from 'react';
import { Result } from 'antd';
import { hasRolePermission } from '@/utils/permission';
import type { PermissionAction } from '@/utils/permission';
import { useAuthStore } from '@/stores';
import { Button } from '@/components/common';
import CustomModal from '@/components/common/Modal';
import InfoCircle from '@/assets/icons/info-circle.svg';

interface ProtectedRouteProps {
  children: React.ReactNode;
  pageKey: PermissionAction;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, pageKey }) => {
  const logout = useAuthStore(state => state.logout);
  const hasPermission = hasRolePermission(pageKey);

  const handleLogout = async () => {
    await logout();
  };

  if (!hasPermission) {
    return (
      <>
        <Result
          status="403"
          title="403"
          subTitle="申し訳ございません。このページにアクセスする権限がありません。"
        />
        <CustomModal
          open={true}
          onCancel={handleLogout}
          title="確認"
          icon={
            <img
              src={InfoCircle}
              alt="info"
              className="confirm-modal-icon primary"
              width={28}
              height={28}
            />
          }
          width={540}
          footer={
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <Button variant="primary" onClick={handleLogout}>
                OK
              </Button>
            </div>
          }
        >
          <p className="confirm-modal-message">
            この機能へのアクセス権がなくなります。続行するには再度ログインしてください。
          </p>
        </CustomModal>
      </>
    );
  }

  return <>{children}</>;
};

